import { useIsMobileHook } from '@teliaee/telia-common-components';
import React from 'react';
import { Card, CardContent, Grid, GridColumn, Modal, useCurrentBreakPoint } from 'telia-front-react';
import JsxRenderer from '../../content/JsxRenderer';
import { normalizeId } from '../../util/TextUtil';
import { PrivateMobileCardsAdditionalOptions } from '../PrivateMobileCards';
import PrivateMobileInclusions from './PrivateMobileInclusions';
import PrivateMobileCard, { PrivateMobileCardProps } from './../PrivateMobileCard';
import PrivateMobileNetflix from './PrivateMobileNetflix';

const PrivateMobileDetailsModal = (
  props: PrivateMobileCardProps & { additionalOptionsContents?: PrivateMobileCardsAdditionalOptions[] }
): React.JSX.Element => {
  const { packageName, additionalOptionsContents, additionalOptions } = props;
  const { isMobile } = useIsMobileHook();
  const breakPoint = useCurrentBreakPoint();
  const packageIncludesNetflix = packageName?.toLowerCase().includes('netflix');

  const matchedAdditionalOptions = additionalOptionsContents?.find((option) => option.name === additionalOptions);

  return (
    <Modal aria-labelledby={`mobile-package-title-${normalizeId(packageName)}`}>
      <Grid equalHeight verticalGutter={breakPoint === 'xs' ? 'medium' : 'default'}>
        <GridColumn width={['xs-12', 'lg-9']}>
          <Card padding={isMobile ? 'small' : 'medium'}>
            <CardContent background="neutral-bg-level-2">
              <Grid>
                <GridColumn width={['xs-12', 'sm-5']}>
                  <PrivateMobileCard {...props} hideViewDetailsButton={true} headingLevel={1} />
                </GridColumn>
                <GridColumn width={['xs-12', 'sm-7']}>
                  <>
                    <PrivateMobileInclusions {...props} />
                    {packageIncludesNetflix && <PrivateMobileNetflix />}
                  </>
                </GridColumn>
              </Grid>
            </CardContent>
          </Card>
        </GridColumn>
        <GridColumn width={['xs-12', 'lg-3']}>
          <Card type="light" padding={isMobile ? 'small' : 'medium'}>
            <CardContent background="neutral-bg-level-3">
              <JsxRenderer jsx={matchedAdditionalOptions?.jsx || ''} doNotScroll />
            </CardContent>
          </Card>
        </GridColumn>
      </Grid>
    </Modal>
  );
};

export default PrivateMobileDetailsModal;
